export const ECWID_STORE_ID = "88026380";
export const ECWID_ACCESS_TOKEN = "secret_Jx3TRcj9PWcuhpjsygNwRfkpyUytxtDg";